var MultiCol = (function () {
  

  var Utility = window.Utility || {};

  Utility.log('MultiCol.js loaded');

  var colWrapper = $('.col-wrapper');

  var article = $('.col-wrapper article');

  var articleHeader = $('.col-wrapper article h6');

  var articleSubCopy = $('.col-wrapper article .sub-copy');

  var articleFirst = $('.col-wrapper article:first-child');

  var articleLast = $('.col-wrapper article:last-child');

  var multiColTitle01 = $('.multi-col-tile-01');

  function multiColWidth() {

    if (colWrapper.hasClass('cols-2')) {
      article.addClass('col-md-18');
    } else if (colWrapper.hasClass('cols-2-25-75')) {
      articleFirst.addClass('col-md-9');

      articleLast.addClass('col-md-27');
    } else if (colWrapper.hasClass('cols-2-75-25')) {
      articleFirst.addClass('col-md-27');

      articleLast.addClass('col-md-9');
    } else if (colWrapper.hasClass('cols-2-33-66')) {
      articleFirst.addClass('col-md-12');

      articleLast.addClass('col-md-24');
    } else if (colWrapper.hasClass('cols-2-66-33')) {
      articleFirst.addClass('col-md-24');

      articleLast.addClass('col-md-12');
    } else if (colWrapper.hasClass('cols-3')) {
      article.addClass('col-md-12');
    } else if (colWrapper.hasClass('cols-4')) {
      article.addClass('col-md-9');
    }
  }

  function emptyContent() {
    $('.col-wrapper article header').each(function () {
      if ($.trim($(this).text()) === '') {
        $(this).hide();
      }
    });

    $(articleHeader).each(function () {
      if ($.trim($(this).text()) === '') {
        $(this).next('div').hide();
      }
    });

    $(articleSubCopy).each(function () {
      if ($.trim($(this).text()) === '') {
        $(this).remove();
      }
    });

    $('.multi-col .acr-cta-text').each(function () {
      if ($.trim($(this).text()) === '') {
        $(this).remove();
      }
    });

    $('.multi-col .col-wrapper img').error(function () {
      $(this).hide();
      $(this).parent().closest(multiColTitle01)
        .css('min-height', '17rem');
    });
  }

  function init() {
    multiColWidth();

    emptyContent();
  }

  return {
    init: init,
  };
}());
